import UserAccessRightsPage from "../../component/users/dynamic-users/UserAccessRights"

 
function UserAccessRights() {
  return (
    <div className="page-body"><UserAccessRightsPage/></div>
  )
}

export default UserAccessRights